import * as React from 'react'
import { useQueryClient } from '@tanstack/react-query'
import RefreshColor from '../../../assets/icons_new/RefreshColor.svg'
import { CompanyNameBadge } from '@/modules/drivers/shared/viewBars/CompanyNameBadge'

const BillingBasicActionBar: React.FC = () => {
  const queryClient = useQueryClient()

  const handleRefresh = async () => {
    await queryClient.invalidateQueries({
      predicate: (q) =>
        typeof q.queryKey[0] === 'string' &&
        (q.queryKey[0] as string).startsWith('billing.'),
    })
  }

  return (
    <div className="tw-relative tw-z-[100] tw-w-full">
      <div className="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-3 tw-px-4 tw-py-1.5">
        <div className="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-gap-3">
          <div className="tw-shrink-0">
            <CompanyNameBadge />
          </div>
        </div>

        <div
          className="tw-shrink-0 tw-cursor-pointer hover:tw-opacity-90"
          onClick={handleRefresh}
        >
          <img src={RefreshColor} alt="Refresh Icon" />
        </div>
      </div>
    </div>
  )
}

export default BillingBasicActionBar
